import LinearProgress from '@mui/material/LinearProgress';

export function VerticalLinearProgressBar({ progress }: { progress: number }) {
  return (
    <LinearProgress
      variant="determinate"
      value={progress}
      sx={{
        width: '2px',
        height: 'auto',
        [`& .MuiLinearProgress-bar`]: {
          backgroundColor: 'neutral.lighter',
          transform: `translateY(${progress}%)!important`,
        },
        [`&.MuiLinearProgress-colorPrimary`]: {
          backgroundColor: 'nwGreens.light',
        },
      }}
    />
  );
}
